import moment from 'moment'
import momenttz from '../component/helpers/momenttz'
import { api } from "../api/apiCore";


export function getEventByTimestamp(data) {
	const url = `/device/${data.device_id}/event?start_ts=${data.timestamp}`;

	return api.get(url)
}

export function getEventById(data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'customer_service':
		case 'sales_demo':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'partner_view':
			url = `/partners/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'storage_manager':
		case 'storage_user':
		case 'custom_user':
			url = `/events/${data.event_id}`;
			break;
	}

	return api.get(url)
}

export function getEventByIdWithType(data) {
	const url = `/event/${data.event_id}/type/${data.event_type}`;

	return api.get(url)
}

export function deleteEvent(data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'partner_view':
			url = `/partners/companies/${data.company_name}/events/${data.event_id}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'storage_manager':
		case 'storage_user':
		case 'custom_user':
			url = `/events/${data.event_id}`;
			break;
	}

	return api.delete(url);
}

export function getEventsOfCompanyAndRange(data) {
	let url = `/companies/${data.company_id}/events/list?start_ts=${data.start_ts}&end_ts=${data.end_ts}`;

	if (data.page_number) {
		url += `&page_number=${data.page_number}`
	}

	if (data.page_size) {
		url += `&page_size=${data.page_size}`
	}

	if (data.filters) {
		url += `&filters=${data.filters}`
	}

	if (data.videostatuses) {
		url += `&video_statuses=${data.videostatuses}`
	}

	if (data.groups) {
		url += `&group_ids=${data.groups}`
	}

	if (data.search_type) {
		url += `&search_type=${data.search_type}`
	}

	if (data.search) {
		url += `&search=${data.search}`
	}

	if (data.order) {
		url += data.order
	}

	if (data.search_by_id) {
		url += `&search_by_id=${data.search_by_id}`
	}

	//* event_ids is used when we want to get single event (or several events) by id
	if (data.event_ids) {
		url += `&event_ids=${data.event_ids}`
	}

	//* device_ids is used when we want to get events of single device (or several devices) by device_id (used for Webfleet page)
	if (data.device_ids) {
		url += `&device_ids=${data.device_ids}`
	}

	if (data.is_flood) {
		url += `&is_flood=${data.is_flood}`
	}

	if (data.is_datausage_locked) {
		url += `&is_data_usage_locked=${data.is_datausage_locked}`
	}

	return api.get(url)
}

export function changeEventNote (data) {
	const url = `/event/${data.event_id}/custom_event_type`;
	const form = new FormData();
	form.append('description', data.description);
	form.append('partner_name', data.partner_name);
	form.append('company_name', data.company_name);
	form.append('has_review', data.has_review);

	return api.postForm(url, form);
}

export function getEventSnapshots(data) {
	let url;
	switch(data.user_role) {
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'custom_user':
			url = `/events/${data.event_id}/snapshots`;
			break;
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}/snapshots`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}/snapshots`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/events/${data.event_id}/snapshots`;
			break;
		case 'partner_view':
			url = `/partner_view/companies/${data.company_name}/events/${data.event_id}/snapshots`;
			break;
		case 'sales_demo':
			url = `/sales_demo/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}/snapshots`;
			break;
		default:
			url = `/companies/${data.company_name}/events/${data.event_id}/snapshots`;
			break
	}

	return api.get(url)
}

export function getEventVideo(data) {
	let url;
	switch (data.user_role) {
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/events/${data.event_id}/videos?video_type=${data.type}`;
		break;
	case 'system_admin':
		url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}/videos?video_type=${data.type}`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}/videos?video_type=${data.type}`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${data.company_name}/events/${data.event_id}/videos?video_type=${data.type}`;
		break;
	case 'partner_view':
		url = `/partner_view/companies/${data.company_name}/events/${data.event_id}/videos?video_type=${data.type}`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${data.partner_name}/companies/${data.company_name}/events/${data.event_id}/videos?video_type=${data.type}`;
		break;
		break;
	default:
		break;
	}

	return api.get(url)
}

export function addDriverToEvent(data) {
	let url = `/events/${data.event_id}`

	if (data.driver_id) {
		url += `?driver_id=${data.driver_id}`
	}

	return api.postForm(url);
}

export function requestEventVideo(data) {
	const url = data.snapshot_only ? `/events/custom_snapshots_clip` : `/events/custom_clips`;
	const form = new FormData();
	form.append('device_id', data.device_id);
	form.append('start_ts', data.start_ts || momenttz(data.timestamp).utc().format('YYYYMMDDHHmmss'));
	form.append('end_ts', data.end_ts || momenttz(data.timestamp).add(data.length, 'seconds').utc().format('YYYYMMDDHHmmss'));

	if (data.description) {
		form.append('custom_clip_type', data.description);
	}

	return api.putForm(url, form);
}

export function requestFloodDownload(data) {
	const url = `/events/flood_download`
	const form = new FormData();
	form.append('event_id', data.event_id)

	return api.postForm(url, form);
}

export function requestCustomAlertVideo(data) {
	const url = `/events/custom_alert_clips`;
	const form = new FormData();
	form.append('device_id', data.device_id);
	form.append('timestamp', moment(data.timestamp).format('YYYYMMDDHHmmss'));
	form.append('alert_type', data.alert_type);

	return api.putForm(url, form);
}

export function requestCustomAlertSnapshot(data) {
	const url = `/events/custom_alert_snapshots`;
	const form = new FormData();
	form.append('device_id', data.device_id);
	form.append('timestamp', moment(data.timestamp).format('YYYYMMDDHHmmss'));
	form.append('alert_type', data.alert_type);

	return api.putForm(url, form);
}

export function getAvailableDatesOfCompany(data) {
	const tz = momenttz().utcOffset();
	const timezone = 'UTC' + ((tz > 0) ? '+' : '') + tz/60
	const tzname = Intl.DateTimeFormat().resolvedOptions().timeZone

	let url;
	switch (data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/events/dates?start_ts=${data.start_ts}&timezone=${timezone}&tzname=${tzname}`
			break
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/events/dates?start_ts=${data.start_ts}&timezone=${timezone}&tzname=${tzname}`
			break
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/events/dates?start_ts=${data.start_ts}&timezone=${timezone}&tzname=${tzname}`
			break
		case 'partner_view':
			url = `/partner_view/companies/${data.company_name}/events/dates?start_ts=${data.start_ts}&timezone=${timezone}&tzname=${tzname}`
			break
		case 'sales_demo':
			url = `/sales_demo/partner/${data.partner_name}/companies/${data.company_name}/events/dates?start_ts=${data.start_ts}&timezone=${timezone}&tzname=${tzname}`
			break
		default:
			url = `/companies/${data.company_name}/events/dates?start_ts=${data.start_ts}&timezone=${timezone}&tzname=${tzname}`
			break
	}

	if (data.search_type) {
		url += `&search_type=${data.search_type}`
	}

	if (data.search) {
		url += `&search=${data.search}`
	}

	if (data.is_flood) {
		url += `&is_flood=${data.is_flood}`
	}

	if (data.is_datausage_locked) {
		url += `&is_datausage_locked=${data.is_datausage_locked}`
	}

	if (data.device_ids) {
		url += `&device_ids=${data.device_ids}`
	}

	return api.get(url)
}

export function getAvailableDatesOfDevice(data) {
	const tz = momenttz().utcOffset();
	const timezone = 'UTC' + ((tz > 0) ? '+' : '') + tz/60
	const tzname = Intl.DateTimeFormat().resolvedOptions().timeZone
	const url = `/devices/${data.device_id}/events/dates?start_ts=${data.start_ts}&timezone=${timezone}&tzname=${tzname}`

	return api.get(url)
}

export function getEventsOfCompany(data) {
	let url;
	switch (data.user_role) {
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/devices/alerts?start_ts=${data.start_ts}&end_ts=${data.end_ts}&ids=${data.device_ids}&alert_type=${data.alert_types}&event_type=${data.event_types}`;
		break;
	case 'system_admin':
		url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/devices/alerts?start_ts=${data.start_ts}&end_ts=${data.end_ts}&ids=${data.device_ids}&alert_type=${data.alert_types}&event_type=${data.event_types}`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/devices/alerts?start_ts=${data.start_ts}&end_ts=${data.end_ts}&ids=${data.device_ids}&alert_type=${data.alert_types}&event_type=${data.event_types}`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${data.company_name}/devices/alerts?start_ts=${data.start_ts}&end_ts=${data.end_ts}&ids=${data.device_ids}&alert_type=${data.alert_types}&event_type=${data.event_types}`;
		break;
	case 'partner_view':
		url = `/partner_view/companies/${data.company_name}/devices/alerts?start_ts=${data.start_ts}&end_ts=${data.end_ts}&ids=${data.device_ids}&alert_type=${data.alert_types}&event_type=${data.event_types}`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${data.partner_name}/companies/${data.company_name}/devices/alerts?start_ts=${data.start_ts}&end_ts=${data.end_ts}&ids=${data.device_ids}&alert_type=${data.alert_types}&event_type=${data.event_types}`;
		break;
	default:
		break;
	}

	return api.get(url)
}

export function getAlertsOfDevice(data) {
	const url = `/devices/${data.device_id}/alerts?start_ts=${data.start_ts}&end_ts=${data.end_ts}&alert_type=${data.alert_types}&event_type=${data.event_types}`;

	return api.get(url)
}


export function restoreFromArchiveWCSEvent (data) {
	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/wcs/event/${data.event_id}/restore`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/wcs/event/${data.event_id}/restore`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${data.company_name}/wcs/event/${data.event_id}/restore`;
			break;
		default:
			url = `/wcs/event/${data.event_id}/restore`;
			break;
	}

	return api.postForm(url);
}

export function requestEventShare(data) {
	const url = `/events/${data.event_id}/share`
	const form = new FormData()
	form.append('company_id', data.company_id)
	form.append('email', data.email)
	form.append('expiration', data.expiration)
	if (data.message) form.append('message', data.message)
	if (data.subject) form.append('subject', data.subject)

	return api.putForm(url, form);
}

export function getEventsFilters(data) {
    let url;
    switch(data.user_role) {
        case 'system_admin':
            url = `/system_admin/partner/${data.partner_name}/companies/${data.company_name}/events/filters?start_ts=${data.start_ts}&end_ts=${data.end_ts}`
            break
        case 'customer_service':
            url = `/customer_service/partner/${data.partner_name}/companies/${data.company_name}/events/filters?start_ts=${data.start_ts}&end_ts=${data.end_ts}`;
            break
        case 'partner':
            url = `/partners/companies/${data.company_name}/events/filters?start_ts=${data.start_ts}&end_ts=${data.end_ts}`
            break
        case 'partner_view':
            url = `/partner_view/companies/${data.company_name}/events/filters?start_ts=${data.start_ts}&end_ts=${data.end_ts}`
            break
        default:
            url = `/events/filters?start_ts=${data.start_ts}&end_ts=${data.end_ts}`
            break
    }

    if (data.sn) {
        url = url + `&sn=${data.sn}`
    }

	return api.get(url)
}

export function flagEvent(data) {
	const url = `/events/${data.id}/flagged`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.putForm(url, form);
}

export function unFlagEvent(data) {
	const url = `/events/${data.id}/flagged`;

	return api.delete(url);
}

export function deleteEventById(data) {
	const url = `/events/${data.event_id}`;
	const form = new FormData();
	form.append('wcs', data.wcs)

	return api.delete(url, {
		data: form
	});
}

export function sendContextVideo(data) {
	const url = `/events/context_video_clip`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.putForm(url, form);
}

export function toggleFeedback(data) {
	const { event_id, ...rest } = data;
	let url = `/events/${event_id}/feedback`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function restoreEventById(data) {
	const url = `/event/${data.event_id}/restore`;

	return api.postForm(url);
}

export function addEventSubscriber(data) {
	const { event_id, ...rest } = data;
	let url = `/event/${event_id}/restore/subscribers`;

	const form = new FormData();
	for (let key in rest) {
		form.append(key, rest[key])
	}

	return api.postForm(url, form);
}

export function eventVideoRequest(data) {
	const url = `/events/flood_download`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function eventAddLabel(event_id, data) {
	const url = `/event/${event_id}/label`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function getFlaggedEvents(data) {
	let params = '';
	for (const key in data) {
		params += `${(!params ? '?' : '&')}${key}=${data[key]}`
	}
	const url = `/events/flagged${params}`;

	return api.get(url);
}

export function getEventDriver(data) {
	const { eventId } = data;
	const url = `/event/${eventId}/driver`;

	return api.get(url);
}

export function getEventsFeedback(data) {
	const { event_id } = data;
	const url = `/events/${event_id}/feedback`;

	return api.get(url);
}

export function getEventsPermalink(data) {
	const { permalink_id } = data;
	const url = `/events/${permalink_id}/permalink`;

	return api.get(url);
}

export function getEventsPermalinkHash(data) {
	const { event_hash } = data;
	const url = `/events/permalink/hash/${event_hash}`;

	return api.get(url);
}
